module.exports = __webpack_public_path__ + "img/wave-adventure--full.329a2dd6.jpg";